import { DashboardSummary } from "../../../interface/dashboard.interface";
import DashCard from "./DashCard";
import { fmtCount, fmtMoney } from "./format";

const PLAN_COLORS: Record<string, string> = {
  STANDARD: "#94A3B8",
  BRONZE: "#C08457",
  SILVER: "#9CA3AF",
  GOLD: "#F3A838",
};

const PlansCard = ({ data, className }: { data: DashboardSummary; className?: string }) => {
  const plans = data.subscriptions?.by_plan ?? [];
  const max = Math.max(1, ...plans.map((p) => p.count));
  const sum = plans.reduce((s, p) => s + p.count, 0);

  return (
    <DashCard
      title="Subscriptions by plan"
      subtitle={plans.length ? `${sum.toLocaleString()} active subscriptions` : undefined}
      empty={!plans.length}
      className={className}
    >
      <ul className="space-y-4">
        {plans.map((p) => {
          const key = p.plan.toUpperCase();
          return (
            <li key={p.plan}>
              <div className="mb-1.5 flex items-baseline justify-between gap-3 text-sm">
                <span className="font-medium capitalize text-honeConnectBlack">{p.plan.toLowerCase()}</span>
                <span className="text-xs text-hcMuted">
                  {[
                    p.revenue_ngn !== undefined ? fmtMoney("NGN", p.revenue_ngn, true) : null,
                    p.revenue_usd !== undefined ? fmtMoney("USD", p.revenue_usd, true) : null,
                  ]
                    .filter(Boolean)
                    .join(" · ")}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <div className="h-2 flex-1 rounded-full bg-hcBg">
                  <div
                    className="h-2 rounded-full"
                    style={{ width: `${(p.count / max) * 100}%`, background: PLAN_COLORS[key] ?? "#7600BC" }}
                  />
                </div>
                <span className="w-14 text-right text-sm font-semibold text-honeConnectBlack">{fmtCount(p.count)}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </DashCard>
  );
};

export default PlansCard;
